import React from 'react'
import ArrowLinkSvg from '../../../assets/icons/ArrowLinkSvg'
import ZoomInIcon from '../../../assets/icons/ZoomInIcon'

function SertificateCard({onOpen=()=>{}, url=""}) {
  return (
    <div className=" bg-white relative cursor-pointer group mb-[40px] transition-all duration-[0.8s]">
        <div className='w-full h-[280px] overflow-hidden flex justify-end items-end'>
          <img className=" w-full h-[100%] group-hover:scale-[1.05] transition-all duration-[0.8s]" src={url} />
          <div className='bg-black/30 absolute group-hover:flex left-0 hidden h-[100%] w-[100%]  transition-all duration-[0.8s] overflow-hidden  justify-center items-center'>
            <button onClick={()=>onOpen()}>
              <ZoomInIcon />
            </button>
          </div>
        </div>
       
    </div>
  )
}

export default SertificateCard
